var React = require('react');

function LongArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"stroke":"#fff","strokeWidth":"1.037","d":"M25.057 20.424c0-5.64 4.572-10.212 10.212-10.212m.001 0C29.63 10.212 25.056 5.64 25.056 0M35.27 10.243H0"}));
}

LongArrowRight.defaultProps = {"fill":"none","width":"35","height":"20","viewBox":"0 0 35.27 20.424"};

module.exports = LongArrowRight;

LongArrowRight.default = LongArrowRight;
